var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-image",class:[
    { 'image-disabled': _vm.imageDataModel.block === true },
    { 'image-rest': _vm.imageModel === 'rest' },
    { 'image-selected': _vm.imageModel === 'selected' },
    { 'image-correct': _vm.imageModel === 'correct' },
    { 'image-wrong': _vm.imageModel === 'incorrect' } ],style:(_vm.getImageStyle()),on:{"click":function($event){return _vm.clickAction($event)}},model:{value:(_vm.imageModel),callback:function ($$v) {_vm.imageModel=$$v},expression:"imageModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }